import { getConfigurations } from '../services/api'

export const fetchConfigs = async () => {
  try {
    const configs = await getConfigurations()

    let LOWER_PERCENT = 0
    let UPPER_PERCENT = 0
    let HIGH_PERCENT = 0
    let MAX_PERCENT = 0
    let SURVEY_QUESTION = ''
    let JOB_SITE_CAPACITY = 0

    const LOWER_PERCENT_DESCRIPTION = 'LOWER_YELLOW_THRESHOLD'
    const UPPER_PERCENT_DESCRIPTION = 'UPPER_YELLOW_THRESHOLD'
    const HIGH_PERCENT_DESCRIPTION = 'UPPER_GREEN_THRESHOLD'
    const MAX_PERCENT_DESCRIPTION = 'RED_THRESHOLD_EXCEED_MAX_CAPACITY'

    configs.forEach((item) => {
      if (item.description.includes(HIGH_PERCENT_DESCRIPTION)) {
        HIGH_PERCENT = item.configValue as number
      }
      if (item.description.includes(LOWER_PERCENT_DESCRIPTION)) {
        LOWER_PERCENT = item.configValue as number
      }
      if (item.description.includes(UPPER_PERCENT_DESCRIPTION)) {
        UPPER_PERCENT = item.configValue as number
      }
      if (item.description.includes(MAX_PERCENT_DESCRIPTION)) {
        MAX_PERCENT = item.configValue as number
      }
      if (item.description.includes('SURVEY_QUESTION')) {
        SURVEY_QUESTION = item.configValue as string
      }
      if (item.description.includes('JOB_SITE_CAPACITY')) {
        JOB_SITE_CAPACITY = item.configValue as number
      }
    })

    return {
      LOWER_PERCENT,
      UPPER_PERCENT,
      HIGH_PERCENT,
      MAX_PERCENT,
      SURVEY_QUESTION,
      JOB_SITE_CAPACITY
    }
  } catch (error) {
    console.error('Error fetching threshold percentages:', error)
    throw error
  }
}
